export const MODULE_NAME = 'alerts';
export const SNACKBARS_MODULE_NAME = 'snackbars';
